<h2 mat-dialog-title mat-dialog-draggable-title>
  {{ "title.group_name_field" | translate }}
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="closeDialog()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<form name="form" #f="ngForm" class="form mat-form-field-outline-custom">
  <div class="row mt-3">
    <div class="col-12">
      <label>{{ "form.choose_parent_group" | translate }}</label>
      <mat-form-field appearance="fill">
        <mat-select
          placeholder="Chọn trường/group cha"
          [formControl]="groupField"
        >
          <mat-option>--Chọn--</mat-option>
          <mat-option *ngFor="let item of data" [value]="item"
            >{{ item.orderNo }} - {{ item.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-divider></mat-divider>
  <mat-dialog-actions align="center" class="mt-2">
    <button
      mat-stroked-button
      color="primary"
      class="mr-3"
      type="button"
      (click)="closeDialog()"
    >
      {{ "button.cancel" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      (click)="groupNameField()"
    >
      {{ "button.add" | translate }}
    </button>
  </mat-dialog-actions>
</form>
